import { useRef, useEffect } from 'react';

/**
 * Returns `true` only during the very first render (mount) of a component,
 * and `false` on all subsequent renders.
 *
 * Useful for skipping side effects that should not run on the initial render
 * (e.g. avoid fetching data before state is ready).
 *
 * @returns `true` on the first render, `false` thereafter.
 *
 * @example
 * const isMount = useIsMount();
 * useEffect(() => {
 *   if (!isMount) fetchData(); // skip on mount
 * }, [dependency]);
 */
export const useIsMount = (): boolean => {
	const isMountRef = useRef(true);
	useEffect(() => {
		isMountRef.current = false;
	}, []);
	return isMountRef.current;
};
